@theme {
  --color-primary-50: var(--nsw-blue-50);
  --color-primary-100: var(--nsw-blue-100);
  --color-primary-150: var(--nsw-blue-150);
  --color-primary-200: var(--nsw-blue-200);
  --color-primary-250: var(--nsw-blue-250);
  --color-primary-300: var(--nsw-blue-300);
  --color-primary-350: var(--nsw-blue-350);
  --color-primary-400: var(--nsw-blue-400);
  --color-primary-450: var(--nsw-blue-450);
  --color-primary-500: var(--nsw-blue-500);
  --color-primary-550: var(--nsw-blue-550);
  --color-primary-600: var(--nsw-blue-600);
  --color-primary-650: var(--nsw-blue-650);
  --color-primary-700: var(--nsw-blue-700);
  --color-primary-750: var(--nsw-blue-750);
  --color-primary-800: var(--nsw-blue-800);
  --color-primary-850: var(--nsw-blue-850);
  --color-primary-900: var(--nsw-blue-900);
  --color-primary-950: var(--nsw-blue-950);
  --color-accent-50: var(--nsw-red-50);
  --color-accent-100: var(--nsw-red-100);
  --color-accent-150: var(--nsw-red-150);
  --color-accent-200: var(--nsw-red-200);
  --color-accent-250: var(--nsw-red-250);
  --color-accent-300: var(--nsw-red-300);
  --color-accent-350: var(--nsw-red-350);
  --color-accent-400: var(--nsw-red-400);
  --color-accent-450: var(--nsw-red-450);
  --color-accent-500: var(--nsw-red-500);
  --color-accent-550: var(--nsw-red-550);
  --color-accent-600: var(--nsw-red-600);
  --color-accent-650: var(--nsw-red-650);
  --color-accent-700: var(--nsw-red-700);
  --color-accent-750: var(--nsw-red-750);
  --color-accent-800: var(--nsw-red-800);
  --color-accent-850: var(--nsw-red-850);
  --color-accent-900: var(--nsw-red-900);
  --color-accent-950: var(--nsw-red-950);
  --color-grey-50: var(--nsw-grey-50);
  --color-grey-100: var(--nsw-grey-100);
  --color-grey-150: var(--nsw-grey-150);
  --color-grey-200: var(--nsw-grey-200);
  --color-grey-250: var(--nsw-grey-250);
  --color-grey-300: var(--nsw-grey-300);
  --color-grey-350: var(--nsw-grey-350);
  --color-grey-400: var(--nsw-grey-400);
  --color-grey-450: var(--nsw-grey-450);
  --color-grey-500: var(--nsw-grey-500);
  --color-grey-550: var(--nsw-grey-550);
  --color-grey-600: var(--nsw-grey-600);
  --color-grey-650: var(--nsw-grey-650);
  --color-grey-700: var(--nsw-grey-700);
  --color-grey-750: var(--nsw-grey-750);
  --color-grey-800: var(--nsw-grey-800);
  --color-grey-850: var(--nsw-grey-850);
  --color-grey-900: var(--nsw-grey-900);
  --color-grey-950: var(--nsw-grey-950);
}
